<template>
  <div id="login">
    <section class="bannerprincipal">
      <SiteNav v-if="showNav"></SiteNav>
    </section>

    <section class="py-5" id="reglamento">
      <div class="d-lg-block py-4">&nbsp;</div>

      <div class="container pt-5 pb-0">
        <div class="row" data-aos="fade-up" data-aos-delay="500">
          <div class="col-12 py-5"></div>

          <div class="col-md-12 text-center pb-4 verde fXG ls5">TORNEO</div>

          <div class="row pt-5">
            <div class="col-md-6 pb-5">
              <div class="col-md-12">
                <div class="bordertop">
                  <div class="d-flex align-items-center pb-3">
                    <img
                      src="../assets/imgs/copaprosa2022/torneo/formato.png"
                      alt="Copa Prosa"
                      class="bgblackt"
                    />

                    <strong class="dorado pl-3">Formato</strong>
                  </div>
                </div>
                <p>
                  • Parejas Stableford bola baja con 70% de HCP en dos
                  categorías:
                </p>
                <ul>
                  <li>
                    <p>&bull; Primera Categoría: 0-18</p>
                  </li>
                  <li>
                    <p>&bull; Segunda Categoría: 19-25</p>
                  </li>
                </ul>
                <p>
                  • Las categorías se asignarán por el hándicap más bajo de la
                  pareja al 100% de HCP.
                </p>
                <p>• Primer escopetazo: 7:15 am</p>
                <p>• Inicio del torneo: 7:30 am</p>
                <p>• 2 Equipos de 2 jugadores por hoyo</p>
                <p>
                  <strong>Marcas de salidas:</strong> <br />
                  • <strong>AZULES:</strong> 0-7 de HCP <br />
                  • <strong>BLANCAS:</strong> Caballeros con HCP 8 en adelante
                  <br />
                  • <strong>AMARILLAS:</strong> Seniors (65 años en adelante)
                  <br />
                  • <strong>ROJAS:</strong> Damas
                </p>
              </div>

              <div class="col-12 py-5">
                <div class="d-flex align-items-center pb-3 bordertop">
                  <img
                    class="bgblackt"
                    src="../assets/imgs/copaprosa2022/torneo/sistema.png"
                    alt="Copa Prosa"
                  />

                  <strong class="dorado pl-3">Sistema de juego</strong>
                </div>

                <p>
                  Bola baja Stableford: Los dos participantes deberán de jugar
                  su bola de manera individual y cada uno obtendrá el 70% de su
                  hándicap en las ventajas del campo.
                </p>
                <p>
                  Los jugadores competirán con su score neto, mismo que será
                  contabilizado con la tabla de puntuación y contará la bola
                  baja.
                </p>
                <p>
                  La competencia se sancionará por la cantidad más alta de
                  puntos obtenido por los participantes:
                </p>
                <p>Bogey: 1 punto</p>
                <p>Par: 2 puntos</p>
                <p>Birdie: 3 puntos</p>
                <p>Águila: 4 puntos</p>
                <p>Albatros y Hole in one: 5 puntos</p>

                <p class="bold">Máximo de golpes:</p>
                <p>Par 3: 6 golpes</p>
                <p>Par 4: 7 golpes</p>
                <p>Par 5: 8 golpes</p>

                <p>
                  Una vez realizado este número de golpes, se deberá levantar la
                  pelota. Continuar con más golpes provocará retraso en el ritmo
                  del torneo.
                </p>
              </div>

              <div class="col-12 pb-5">
                <div class="d-flex align-items-center pb-3 bordertop">
                  <img
                    src="../assets/imgs/copaprosa2022/torneo/ajustes.png"
                    alt="Copa Prosa"
                    class="bgblackt"
                  />

                  <strong class="dorado pl-3">Categorías</strong>
                </div>
                <p class="negro">
                  Las categorías son mixtas y se asignarán con base al hándicap
                  más bajo de la pareja al 100%.
                </p>
                <!-- <p>Primera categoría: 0-18</p>
                <p>Segunda categoría: 19-25</p> -->
              </div>

              <div class="col-12 pb-5">
                <div class="d-flex align-items-center pb-3 bordertop">
                  <img
                    src="../assets/imgs/copaprosa2022/torneo/equipos.png"
                    alt="Copa Prosa"
                    class="bgblackt"
                  />

                  <strong class="dorado pl-3">Equipos incompletos</strong>
                </div>
                <p class="negro">
                  Si a un equipo le falta un jugador se sustituirá con jugadores
                  de reserva o se podrá asignar un jugador del equipo contrario
                  (el de menor hándicap). Este último jugará para los dos
                  equipos con un solo score.
                </p>
              </div>

              <div class="col-12 pb-5">
                <div class="d-flex align-items-center pb-3 bordertop">
                  <img
                    src="../assets/imgs/copaprosa2022/torneo/handicaps.png"
                    alt="Copa Prosa"
                    class="bgblackt"
                  />

                  <strong class="dorado pl-3">Hándicaps</strong>
                </div>
                <p>
                  Al momento del registro, serán tomados en cuenta los hándicaps
                  registrados por los jugadores ante un órgano federativo (GHIN,
                  FMG, AGVM u organismo regional). Serán avaladas cartas de
                  profesionales o de clubes, las cuales sólo servirán como
                  referencia. De no poder comprobar el HCP, se pondrá el más
                  bajo del equipo.
                </p>

                <p>
                  Los hándicaps serán validados VS los registrados en la Copa
                  Prosa 2024 y el hándicap máximo de competencia será 25.
                </p>

                <p class="bold">
                  El Comité Organizador se reserva el derecho de revisar y
                  ajustar cualquier HCP que no corresponda a lo declarado y su
                  decisión será inapelable.
                </p>
              </div>

              <div class="col-12 pb-5">
                <div class="d-flex align-items-center pb-3 bordertop">
                  <img
                    src="../assets/imgs/copaprosa2022/torneo/tarjetas.png"
                    alt="Copa Prosa"
                    class="bgblackt"
                  />

                  <strong class="dorado pl-3">Tarjetas</strong>
                </div>
                <p class="negro">
                  En todo momento, las parejas deben anotar su
                  <b>score Gross (los golpes que realizan sin ventaja)</b>.
                  Todos los cálculos correspondientes para obtener resultados
                  finales estarán a cargo del Comité Organizador.
                </p>
                <p class="negro">
                  Serán motivo de descalificación, las tarjetas de score que no
                  sean entregadas con al menos una firma de algún jugador del
                  equipo contrario, así como en la caseta asignada y en el
                  tiempo estipulado (15 minutos después de finalizar el torneo).
                  Tampoco serán aceptadas las tarjetas con tachones y borrones,
                  así como las tarjetas no oficiales del torneo. La tarjeta de
                  score del torneo es el ÚNICO medio oficial para determinar el
                  resultado.
                </p>
              </div>
            </div>

            <div class="col-md-6">
              <div class="col-12">
                <div class="d-flex align-items-center pb-3 bordertop">
                  <img
                    src="../assets/imgs/copaprosa2022/torneo/empates.png"
                    alt="Copa Prosa"
                    class="bgblackt"
                  />

                  <strong class="dorado pl-3">Empates</strong>
                </div>
                <p class="negro">
                  Si dos o más equipos terminan con el mismo número de puntos,
                  ganará el equipo con la menor suma de HCP al 100%. De
                  persistir el empate, serán comparadas las tarjetas de los
                  equipos tomando en cuenta la suma de la pareja a partir del
                  hoyo 1 del campo y así sucesivamente hasta resultar un
                  ganador.
                </p>
              </div>

              <div class="col-12 pb-5">
                <div class="d-flex align-items-center pb-3 bordertop">
                  <img
                    src="../assets/imgs/copaprosa2022/torneo/reglas.png"
                    alt="Copa Prosa"
                    class="bgblackt"
                  />

                  <strong class="dorado pl-3">Reglas</strong>
                </div>
                <p class="negro">
                  El torneo se jugará con base a las reglas vigentes de la USGA
                  adoptadas por la F.M.G., las propias de la competencia y las
                  reglas locales. Ante cualquier controversia, la decisión del
                  Comité Organizador será inapelable y éste tendrá la facultad
                  de realizar cualquier cambio que considere conveniente en
                  beneficio del torneo.
                </p>
                <p class="negro">
                  <strong>Fuera de límites</strong>: Señalado con estacas
                  blancas, bardas, mallas y/o alambradas. <br />

                  <strong>Terreno en reparación</strong>: Señalado -circulado-
                  con cal o pintura blanca (dropeo sin castigo al punto de
                  alivio más cercano). <br />

                  <strong>Bola enterrada en fairway</strong>: Tendrá alivio sin
                  castigo y podrá levantarla, limpiarla y dropearla lo más cerca
                  posible del impacto, sin aproximarse al hoyo.<br />

                  <strong>Obstáculo de agua lateral</strong>: Estará marcado con
                  estacas o líneas rojas.<br />

                  <strong>Obstáculo de agua</strong>: Estará marcado con estacas
                  o líneas amarillas.<br />

                  <strong>Baby Tree</strong>: Si una pelota reposa dentro de un
                  cajete o el cajete influye en la postura, el jugador, sin
                  castigo, podrá marcar, levantar, limpiar y dropear la bola al
                  alivio más cercano sin aproximarse a la bandera.<br />

                  <strong>Jardinera</strong>: Si una pelota reposa dentro de la
                  jardinera o planta de ornato, el jugador, sin opción, deberá
                  dropear la bola al punto de alivio más cercano sin aproximarse
                  a la bandera y con un golpe de castigo. <br />

                  <strong>Camino de concreto</strong>: Si una pelota reposa en
                  el camino o el camino influye en la postura, el jugador, sin
                  castigo, podrá marcar, levantar, limpiar y dropear la bola al
                  alivio más cercano sin aproximarse a la bandera.<br />

                  <strong>Parte integral del campo</strong>: Las marcas de
                  yardaje (tulias) se consideran parte integral del campo, no
                  hay alivio sin castigo.<br />
                </p>
              </div>

              <div class="col-12 pb-5">
                <div class="d-flex align-items-center pb-3 bordertop">
                  <img
                    src="../assets/imgs/copaprosa2022/torneo/suspension.png"
                    alt="Copa Prosa"
                    class="bgblackt"
                  />

                  <strong class="dorado pl-3">Suspensión del torneo</strong>
                </div>
                <p class="negro">
                  En caso de contingencia ambiental y de común acuerdo con la
                  dirección de golf de Bosque Real, el torneo podrá ser
                  suspendido temporal o definitivamente. Los resultados serán
                  calculados tomando en cuenta el menor número de hoyos jugados
                  por los equipos y ganará el de mayor suma de puntos de los
                  hoyos determinados.
                </p>
              </div>

              <div class="col-12 pb-5">
                <div class="d-flex align-items-center pb-3 bordertop">
                  <img
                    src="../assets/imgs/copaprosa2022/torneo/trofeos.png"
                    alt="Copa Prosa"
                    class="bgblackt"
                  />

                  <strong class="dorado pl-3">Trofeos</strong>
                </div>
                <p class="negro">
                  &bull; <strong>1er</strong>, <strong>2do</strong> y
                  <strong>3er</strong> lugar por categoría.
                </p>
                <p>
                  Ganarán las parejas que logren la bola baja con más puntos de
                  cada categoría.
                </p>
                <p class="bold">&bull; El mejor score Gross</p>
                <p>
                  Ganará la pareja en bola baja con el score gross más bajo (sin
                  HCP).
                </p>
              </div>

              <div class="col-12 pb-5">
                <div class="d-flex align-items-center pb-3 bordertop">
                  <img
                    src="../assets/imgs/copaprosa2022/torneo/premios.png"
                    alt="Copa Prosa"
                    class="bgblackt"
                  />

                  <strong class="dorado pl-3">Premios</strong>
                </div>
                <p class="negro">
                  En todo momento, los premios <b>serán acumulables</b>.
                </p>
                <p class="negro">
                  En caso de empate en una dinámica, el criterio de desempate se
                  determinará con base al jugador que realice primero el tiro.
                  Es indispensable validar la distancia y firmar la tabla del
                  juez de dinámica.
                </p>
                <p class="negro">
                  <strong>Hole in one</strong>: Se dará 1 premio a hole in one
                  por hoyo y el tiro se deberá realizar del yardaje estipulado y
                  de las marcas de salida para validarlo. En caso de tener un
                  segundo hole in one en el mismo hoyo, se tomará como mejor
                  o'yes.
                </p>

                <p class="bold negro">
                  Nota: El Comité Organizador se reserva el derecho de hacer
                  cualquier modificación en beneficio del torneo y su decisión
                  será inapelable.
                </p>
              </div>

              <div class="col-12 pb-5">
                <div class="d-flex align-items-center pb-3 bordertop">
                  <img
                    src="../assets/imgs/copaprosa2022/torneo/formato.png"
                    alt="Copa Prosa"
                    class="bgblackt"
                  />

                  <strong class="dorado pl-3">Caddies</strong>
                </div>
                <p class="negro">La cuota de caddies es pagada por Prosa.</p>
              </div>

              <div class="col-12 pb-5">
                <div class="d-flex align-items-center pb-3 bordertop">
                  <img
                    src="../assets/imgs/copaprosa2022/torneo/handicaps.png"
                    alt="Copa Prosa"
                    class="bgblackt"
                  />

                  <strong class="dorado pl-3">Juego lento</strong>
                </div>
                <p class="negro">
                  Se les invita a mantener un buen ritmo en campo. En caso de
                  mantener uno lento, recibirán una primera llamada de atención
                  la cual no será sancionada. Sin embargo, a la segunda se
                  agregará un golpe al score de ambos jugadores.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12 text-center verde fXG ls3 z1">
          <img
            src="../assets/imgs/copaprosa2025/banner-torneo.jpg"
            alt="Copa Prosa"
            class="img-fluid z1"
          />
        </div>
      </div>
    </section>

    <Footer></Footer>
  </div>
</template>

<script>
import SiteNav from "@/components/SiteNavSpecial";
import PasswordReset from "@/components/PasswordReset";

import router from "../router/index";

import Footer from "@/components/FooterNegativo";
import AOS from "aos";
import swal from "sweetalert2";

import { mapState } from "vuex";

export default {
  components: {
    Footer,
    SiteNav,
  },
  data() {
    return {
      loginForm: {
        no_cliente: "",
        password: "",
      },
      signupForm: {
        nombre: "",
        apellido: "",
        email: "",
        password: "",
        estado: "",
        no_cliente: "",
        telefono: "",
        movil: "",
        codigo_pais: "",
        talla: "",
        talla_cubrebocas: "",
      },
      showLoginForm: true,
      showPasswordReset: false,
      showMonedero: false,
      dateType: "text",
      explotar: true,
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
  },
  computed: {
    ...mapState(["userProfile"]),
    showNav() {
      //return Object.keys(this.userProfile).length > 1;
      return true;
    },
  },
  methods: {
    cambiaFechaType() {
      this.dateType = "date";
      if (this.signupForm.fecha_nacimiento == "")
        this.signupForm.fecha_nacimiento = "1900-01-01";
    },
    toggleForm() {
      this.showLoginForm = !this.showLoginForm;
    },
    togglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset;
    },
    login(e) {
      this.$store.dispatch("showLoader", true);

      e.preventDefault();

      const https = require("https");
      var qData = {
        no_cliente: this.loginForm.no_cliente,
        email: this.loginForm.email,
        password: this.loginForm.password,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "login2.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              localStorage.setItem(
                "user_copaprosa2021",
                JSON.stringify(res.usuario)
              );

              router.push("/");
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    signup(e) {
      e.preventDefault();

      if (this.validPass(this.signupForm.password) === false) {
        swal.fire(
          "Oops",
          "La contraseña debe tener al menos 8 dígitos",
          "warning"
        );
        return false;
      }

      console.log({ registro: this.signupForm });
      this.enviaRegistro();
    },
    async enviaRegistro() {
      this.$store.dispatch("showLoader", true);

      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = {
        nombre: this.signupForm.nombre,
        apellido: this.signupForm.apellido,
        email: this.signupForm.email,
        password: this.signupForm.password,
        no_cliente: this.signupForm.no_cliente,
        estado: this.signupForm.estado,
        telefono: this.signupForm.telefono,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registro.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio registro");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
              this.resetForm();
              this.toggleForm();
            } else if (res.status === "correo") {
              swal.fire("Registro", res.msg, "warning");
              this.resetForm();
              this.toggleForm();
            } else {
              swal.fire("Oops", res.msg, "warning");
              this.resetForm();
              this.toggleForm();
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    resetForm() {
      this.signupForm = {
        nombre: "",
        apellido: "",
        email: "",
        password: "",
        estado: "",
        no_cliente: "",
      };
    },
    validPass(password) {
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    validPhone(celular) {
      if (celular.length < 10) {
        return false;
      }
      if (isNaN(celular)) {
        return false;
      }

      return true;
    },
  },
};
</script>
